import { render, staticRenderFns } from "./simOpen9.vue?vue&type=template&id=444b8068&scoped=true&"
import script from "./simOpen9.vue?vue&type=script&lang=js&"
export * from "./simOpen9.vue?vue&type=script&lang=js&"
import style0 from "./simOpen9.vue?vue&type=style&index=0&id=444b8068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b8068",
  null
  
)

export default component.exports